/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LabelType } from '../../models/label-type';
import { Outer } from '../../models/outer';

export interface GetOuter$Params {
  productionOrderId: number;
  labelType?: LabelType;
}

export function getOuter(http: HttpClient, rootUrl: string, params: GetOuter$Params, context?: HttpContext): Observable<StrictHttpResponse<Outer>> {
  const rb = new RequestBuilder(rootUrl, getOuter.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.query('labelType', params.labelType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Outer>;
    })
  );
}

getOuter.PATH = '/api/v1/ProductionOrder/{productionOrderId}/Outer';
